export default "__VITE_ASSET__abd75869__"